import { useState } from "react";
import { BiSearchAlt } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { TransitStation } from "../../Commute/transitApi";
import StationSearchInput from "../../Components/Inputs/StationSearchInput";

/**
 * Home-page search bar for the Lagos train: where you are, where you're going.
 *
 * Uses the same react-select picker as the interstate city search so the tabs
 * behave identically. Replaces the train-ID box — a commuter knows their
 * stations, not the working timetable's train numbers.
 */
const TransitGroup = ({ dark = false }: { dark?: boolean }) => {
  const navigate = useNavigate();
  const [from, setFrom] = useState<TransitStation | null>(null);
  const [to, setTo] = useState<TransitStation | null>(null);

  const canSearch = Boolean(from && to);

  const search = () => {
    if (!from || !to) return;
    const params = new URLSearchParams({ from: from.name, to: to.name });
    navigate(`/train?${params.toString()}`);
  };

  return (
    <div className="w-full">
      <div className="w-full flex items-center gap-2 mt-2">
        <div className="w-4/12">
          <StationSearchInput
            name="From"
            placeholder="Where are you?"
            dark={dark}
            pos="left"
            value={from}
            // Both ends must sit on one line — the published Lagos lines share
            // no station, so a cross-line pair can never be served.
            restrictToLine={to?.lineCode ?? null}
            onChange={(station) => {
              setFrom(station);
              if (station && to && to.lineCode !== station.lineCode) setTo(null);
            }}
          />
        </div>

        <div className="w-4/12">
          <StationSearchInput
            name="To"
            placeholder="Where are you going?"
            dark={dark}
            pos="right"
            value={to}
            restrictToLine={from?.lineCode ?? null}
            onChange={(station) => {
              setTo(station);
              if (station && from && from.lineCode !== station.lineCode) {
                setFrom(null);
              }
            }}
          />
        </div>

        <div className="w-4/12">
          <button
            type="button"
            onClick={search}
            disabled={!canSearch}
            className="w-full h-14 bg-orange-500 text-white rounded flex items-center justify-center gap-2 disabled:opacity-50 hover:bg-orange-400"
          >
            <BiSearchAlt />
            Get schedule
          </button>
        </div>
      </div>

      <p className={dark ? "text-xs text-white/70 mt-3" : "text-xs text-slate-500 mt-3"}>
        Times come from the published LAMATA timetable, not live tracking. Pay
        your fare on board with your Cowry card.
      </p>
    </div>
  );
};

export default TransitGroup;
